import { logInitializedClass } from '../apiTransformers/transformers';
/**
 * ClassLogger - Logs class name when an instance of itself is initialized
 *
 * @param constructor
 * @returns
 */
export function ClassLogger(constructor) {
    return logInitializedClass(constructor);
}
